module.exports = __webpack_public_path__ + "a555442f64dbb3f71d601f3c0cfaaa24.fbx";